import type { FileFormat } from '../../../../types';
import OptionsCheckboxes from './OptionsCheckboxes';
import type { Value } from './types';
import generateOptions from './utils/generateOptions';
import getHiddenCheckboxes from './utils/getHiddenCheckboxes';

interface OptionsCheckboxesContainerProps {
    value: Value;
    fileFormat: FileFormat;
    isNoLanguageFoldersSwitchDisabled: boolean;
    onChange: (value: Value) => void;
}

const OptionsCheckboxesContainer = ({
    value,
    fileFormat,
    isNoLanguageFoldersSwitchDisabled,
    onChange,
}: OptionsCheckboxesContainerProps) => {
    const disabledCheckboxes = getHiddenCheckboxes(fileFormat, value.switchCompact, isNoLanguageFoldersSwitchDisabled);

    return <OptionsCheckboxes value={value} options={generateOptions(disabledCheckboxes)} onChange={onChange} />;
};

export default OptionsCheckboxesContainer;
